import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2ae0bf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-tooltip"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-check-circle"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-exclamation-circle"
}
const _hoisted_4 = {
  key: 2,
  class: "fas fa-times-circle is-danger"
}
const _hoisted_5 = {
  key: 3,
  class: "ml-1 label"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationIndicator',
  props: {
    type: null,
    label: null,
    tooltip: null
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-tooltip": __props.tooltip,
    class: _normalizeClass(["validationIndicator ml-2 has-tooltip-multiline", __props.type])
  }, [
    (__props.type=='success')
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.type=='warning')
      ? (_openBlock(), _createElementBlock("i", _hoisted_3))
      : _createCommentVNode("", true),
    (__props.type=='error')
      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
      : _createCommentVNode("", true),
    (__props.label && __props.label.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})